import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

/** Skips the empty `null`/`undefined` state that cached subjects start and reset with. */
export function defined<T>(): OperatorFunction<T, NonNullable<T>> {
  return filter(
    (value: T): value is NonNullable<T> => value !== null && value !== undefined
  );
}
